import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-svg-sprite',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './svg-sprite.component.html'
})
export class SvgSpriteComponent {}
